import React from 'react';

class AuthCTAButton extends React.Component {
    state={
        hover: false,
        active: this.props.active ? true : false
    }

    hoverToggle(){
        this.setState({
            hover: !this.state.hover
        });
    }

    clickHandler(){
        const action = this.props.action;
        this.props.clickHandler(action);
    }

    render(){
        const ctaColor = window.settings.brand.cta ? window.settings.brand.cta.primary.textColor : '';
        const hoverStyle = (this.state.hover || this.props.active) ? {'color':ctaColor, 'borderColor':ctaColor} : '';

        // console.log(this.props);

        return <button 
                style={{...hoverStyle}}
                onMouseOver={this.hoverToggle.bind(this)}
                onMouseLeave={this.hoverToggle.bind(this)}
                className="news-auth-button"
                type={this.props.btnType || 'submit'}
                onClick={this.clickHandler.bind(this)}
                >
            {this.props.text}
        </button>
    }
}

export default AuthCTAButton;